import { MeUser } from "oneclick-component/src/store/apis/enhancedApi";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

const useMeUser = (): MeUser | null => {
  return useSelector((state: RootState) => state.auth.meUser);
};

export default useMeUser;
